import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { ICertificateRouteHint, RootState } from '@share/utils';
import { IHotelInfo } from '@common-types';
import { isQuintessVacationRental } from '@utils';

import { RoomsSearchList } from '../rooms-search-list';
import { RoomsSearchSearch } from '../rooms-search-search';

import './style.scss';

interface IProps {
  hotel: IHotelInfo;
  refAnchor: React.RefObject<HTMLDivElement>;
  matches?: boolean;
  isVacationRentals?: boolean;
  isFocused?: boolean;
  isStaticDetail?: boolean;
  certificateRoute?: ICertificateRouteHint;
}

export function RoomsSearch(props: IProps): JSX.Element {
  const roomsSearchStore = useSelector((state: RootState) => state.roomsSearchStore);
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { timer, error } = roomsSearchStore;
  const { account } = loginStore;

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  const isVacationRental = props.hotel.hotelDetails?.isVacationRental;
  // Quintess sells fixed whole-house stays, so re-running dates and party size from
  // here does not apply; alternate dates are offered inside the entire-home panel.
  const isQuintess = isQuintessVacationRental(props.hotel);
  const isAshevillePlay = account?.isAshevillePlay;
  const certificateId = props.certificateRoute?.certificateId;

  return (
    <div className="rooms-search" ref={props.refAnchor}>
      {!isAshevillePlay && (
        <div className="rooms-search__header secondary-font">
          <FormattedMessage
            id={isVacationRental ? 'property.availability' : 'rooms.availability'}
          />
        </div>
      )}

      <div className="rooms-search__search-wrapper">
        {!isQuintess && (
          <RoomsSearchSearch
            hotel={props.hotel}
            refAnchor={props.refAnchor}
            matches={props.matches}
            isVacationRentals={props.isVacationRentals}
            isFocused={props.isFocused}
            isStaticDetail={props.isStaticDetail}
            certificateRoute={props.certificateRoute}
          />
        )}

        {!isAshevillePlay && error && (
          <div className="date-picker__error" title={error} style={{ marginTop: '5px' }}>
            {error}
          </div>
        )}

        <RoomsSearchList
          hotel={props.hotel}
          isVacationRentals={props.isVacationRentals}
          isStaticDetail={props.isStaticDetail}
          isFocused={props.isFocused}
          certificateId={certificateId}
          certificateItemId={props.certificateRoute?.certificateItemId}
        />
      </div>
    </div>
  );
}
